import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import createBrowserClient from "payrailz-js-client-sdk";

import { getUri, createIAVServerClient } from "./utils";

import { UNAUTHORIZED, LOGOUT } from "./actions/auth";
import { setMicroService } from "./actions/microService";
import appReducer from "./reducers";
import saga from "./sagas";

const isClearAction = (type: string) =>
  type === UNAUTHORIZED || type === LOGOUT;

const configureStore = (
  env: string,
  adminUserId: string,
  httpClient?: Function,
  _externalSsoServerClient?: Function,
  microService?: string
) => {
  const sdk = createBrowserClient({
    httpClient,
    authHost: getUri("/auth", env),
  });
  // Use default axios for IAV server to ensure we control the URL
  // externalSsoServerClient may have baseURL set to SSO UI domain
  const iavServer = createIAVServerClient(env);

  const sagaMiddleware = createSagaMiddleware({ context: { sdk, iavServer, adminUserId } });

  const composeEnhancers: typeof compose =
    // eslint-disable-next-line no-underscore-dangle
    (typeof window !== "undefined" && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

  const rootReducer = (state: any, action: any) => {
    let currentState = state;
    if (isClearAction(action.type)) {
      const { fspConfig } = currentState;
      if (window.Trustly) {
        window.Trustly.destroy();
      }
      currentState = {
        auth: { authenticated: false },
        fspConfig,
        microService,
      };
    }
    return appReducer(currentState, action);
  };

  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware))
  );

  sagaMiddleware.run(saga);

  if (microService) {
    store.dispatch(setMicroService(microService));
  }

  return store;
};

export default configureStore;
